"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bitcoinAddressTypes = void 0;
exports.bitcoinAddressTypes = {
    addressTypesNumber: { p2pk: 0, p2pkh: 1, p2sh: 2, p2wpkh: 3, p2wsh: 4, p2tr: 5 },
    addressTypes: ["p2pk", "p2pkh", "p2sh", "p2wpkh", "p2wsh", "p2tr"],
};
//# sourceMappingURL=bitcoin-address-types.js.map